import {
  AxiosError,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";

export const isAxiosDebugEnabled = process.env.NODE_ENV === "development";

const redactHeaders = (
  headers: InternalAxiosRequestConfig["headers"]
): Record<string, string> => {
  const result: Record<string, string> = {};
  if (!headers) return result;

  const entries =
    typeof headers.toJSON === "function"
      ? Object.entries(headers.toJSON())
      : Object.entries(headers as Record<string, string>);

  for (const [key, value] of entries) {
    if (value == null) continue;
    result[key] =
      key.toLowerCase() === "authorization" ? "[REDACTED]" : String(value);
  }

  return result;
};

const getRequestUrl = (config: InternalAxiosRequestConfig) => {
  const base = config.baseURL?.replace(/\/$/, "") ?? "";
  const path = config.url?.startsWith("http")
    ? config.url
    : `${base}${config.url ?? ""}`;
  return path;
};

export const logAxiosRequest = (config: InternalAxiosRequestConfig) => {
  const method = (config.method ?? "get").toUpperCase();
  const label = `%c[Axios] → ${method} ${getRequestUrl(config)}`;
  console.groupCollapsed(label, "color:#2563eb;font-weight:600");
  console.log("Headers:", redactHeaders(config.headers));
  if (config.params !== undefined) console.log("Params:", config.params);
  if (config.data !== undefined) console.log("Body:", config.data);
  console.groupEnd();
  return config;
};

export const logAxiosResponse = (response: AxiosResponse) => {
  const { config, status, statusText, data } = response;
  const method = (config.method ?? "get").toUpperCase();
  const label = `%c[Axios] ← ${status} ${statusText} ${method} ${getRequestUrl(config)}`;
  console.groupCollapsed(label, "color:#16a34a;font-weight:600");
  console.log("Response:", data);
  console.groupEnd();
  return response;
};

export const logAxiosError = (error: AxiosError) => {
  const config = error.config;
  const method = (config?.method ?? "get").toUpperCase();
  const url = config ? getRequestUrl(config) : "unknown";
  const status = error.response?.status;
  const label = `%c[Axios] ✕ ${status ?? "ERR"} ${method} ${url}`;
  console.groupCollapsed(label, "color:#dc2626;font-weight:600");
  if (config) {
    console.log("Request headers:", redactHeaders(config.headers));
    if (config.data !== undefined) console.log("Request body:", config.data);
  }
  if (error.response?.data) console.log("Error response:", error.response.data);
  else console.log("Message:", error.message);
  console.groupEnd();
  return Promise.reject(error);
};
